const policyContent = document.querySelector('.shopify-policy__body .rte');

const policyProfiles = {
  '/policies/shipping-policy': { kind: 'shipping' },
  '/policies/refund-policy': { kind: 'returns' },
};

const profile = policyProfiles[window.location.pathname];

if (policyContent && profile) {
  const policyContainer = policyContent.closest('.shopify-policy__container');
  const shopifyTitle = policyContainer?.querySelector('.shopify-policy__title');
  const contentTitle = policyContent.querySelector(':scope > h1:first-child');
  const title = contentTitle || shopifyTitle?.querySelector('h1');
  const intro = contentTitle?.nextElementSibling?.matches('p') ? contentTitle.nextElementSibling : null;

  policyContent.classList.add('inflyn-policy-page');
  policyContent.dataset.policyKind = profile.kind;
  if (shopifyTitle) shopifyTitle.hidden = true;

  const hero = document.createElement('header');
  const heroInner = document.createElement('div');
  const eyebrow = document.createElement('p');

  hero.className = 'inflyn-policy-hero';
  heroInner.className = 'inflyn-policy-hero__inner';
  eyebrow.className = 'inflyn-policy-hero__eyebrow';
  eyebrow.textContent = 'Customer care';
  heroInner.append(eyebrow);

  if (title) {
    title.classList.add('inflyn-policy-hero__title');
    heroInner.append(title);
  }

  if (intro) {
    intro.classList.add('inflyn-policy-hero__intro');
    heroInner.append(intro);
  }

  hero.append(heroInner);

  const article = document.createElement('article');
  article.className = 'inflyn-policy-article';
  article.append(...Array.from(policyContent.childNodes));

  const headings = Array.from(article.querySelectorAll(':scope > h2'));
  const usedIds = new Set();
  const navigation = document.createElement('details');
  const navigationSummary = document.createElement('summary');
  const navigationList = document.createElement('ol');

  navigation.className = 'inflyn-policy-nav';
  navigationSummary.textContent = 'On this page';

  headings.forEach((heading, index) => {
    const headingText = heading.textContent.trim();
    const baseId =
      headingText
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[^a-z0-9\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-') || `section-${index + 1}`;

    let headingId = `policy-${baseId}`;
    let duplicateIndex = 2;

    while (usedIds.has(headingId) || document.getElementById(headingId)) {
      headingId = `policy-${baseId}-${duplicateIndex}`;
      duplicateIndex += 1;
    }

    usedIds.add(headingId);
    heading.id = headingId;
    heading.dataset.sectionIndex = String(index + 1).padStart(2, '0');

    const item = document.createElement('li');
    const indexLabel = document.createElement('span');
    const link = document.createElement('a');

    indexLabel.textContent = String(index + 1).padStart(2, '0');
    link.href = `#${headingId}`;
    link.textContent = headingText;
    item.append(indexLabel, link);
    navigationList.append(item);
  });

  navigation.append(navigationSummary, navigationList);
  if (window.matchMedia('(min-width: 990px)').matches) navigation.open = true;

  const related = document.createElement('nav');
  const relatedLabel = document.createElement('p');
  const relatedLinks = [
    ['/policies/shipping-policy', 'Shipping'],
    ['/policies/refund-policy', 'Returns'],
    ['/pages/faq', 'FAQ'],
  ];

  related.className = 'inflyn-policy-related';
  related.setAttribute('aria-label', 'Related customer care pages');
  relatedLabel.textContent = 'Related pages';
  related.append(relatedLabel);

  relatedLinks.forEach(([href, label]) => {
    const link = document.createElement('a');
    link.href = href;
    link.textContent = label;
    if (window.location.pathname === href) link.setAttribute('aria-current', 'page');
    related.append(link);
  });

  const sidebar = document.createElement('aside');
  sidebar.className = 'inflyn-policy-sidebar';
  sidebar.append(navigation, related);

  const layout = document.createElement('div');
  layout.className = 'inflyn-policy-layout';
  layout.append(sidebar, article);

  const support = document.createElement('aside');
  support.className = 'inflyn-policy-support';
  support.innerHTML = `
    <div>
      <p>Still need help?</p>
      <h2>Talk to our support team.</h2>
    </div>
    <a href="/pages/contact">Contact us <span aria-hidden="true">&rarr;</span></a>
  `;

  policyContent.replaceChildren(hero, layout, support);
}
